import I from 'components/I'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import Alert from 'react-bootstrap/Alert'
import FlashAlert from './FlashAlert'
import ClickableAlert from './ClickableAlert'
import { ALERT_FAKE_LINK } from './actions'
import Alerts from 'utils/Alerts'

export default function OrderAlert({ list, doClose }) {
	const { t } = useTranslation()

	if (list.length == 0) {
		return null //safety check
	}

	const finalLink = (id, fakeValue) => id === 0? fakeValue : (id? `/order/${id}` : '')
	const isFlash   = list[0].flash

	let id, order, onClose, btnText, link, title, body, progress, maxProgress
	const br = isFlash? <br/> : <>&nbsp;</>
	if (list.length == 1) {
		({ content: order, id, progress, maxProgress } = list[0])
		btnText = t('Open')
		link    = finalLink(order.id, ALERT_FAKE_LINK)
		title   = <>🔔{br} {t('New Order')}</> // eslint-disable-line i18next/no-literal-string
		body    = t('#{{order}} for {{customer}}', { order: order.number, customer: order.customer_name })
	} else if (list.length > 1) {
		const MAX_ORDERS = (isFlash? FlashAlert : ClickableAlert).MAX_ORDERS
		const hidden     = Math.max(0, list.length - MAX_ORDERS)
		;({ progress, maxProgress } = list[list.length - 1])
		onClose = doClose(list)
		btnText = t('Open first', { context: 'first order from list' })
		link    = finalLink(list[0].id, '#')
		title   = <p>🔔{br} <Trans count={list.length}><b>{{ count: list.length }}</b> New Orders</Trans></p> // eslint-disable-line i18next/no-literal-string
		body    = (
			<ul>
				{list.slice(0, MAX_ORDERS).map(({ content: order }, i) => (
					<li key={i}>
						<Trans>
							<Alert.Link as={Link} to={finalLink(order.id, '#')}>#{{ order: order.number }}</Alert.Link>{' '}
							for {{ customer: order.customer_name }}
						</Trans>
						{i == MAX_ORDERS - 1 && hidden > 0? <><br/><I en>{t('...and {{count}} more.', { count: hidden, context: 'end of notification popup for many orders' })}</I></> : ''}
					</li>
				))}
			</ul>
		)
	}

	return isFlash?
		<FlashAlert {...{ title, link, btnText, id, onClose }}>{body}</FlashAlert> :
		<ClickableAlert type={Alerts.TYPES.INFO} {...{ id, link, onClose, progress, maxProgress }}
		                content={<>{title} {body}</>}/>
}
